module.exports = __webpack_public_path__ + "static/media/home1.61979723.png";